import { createRouter, createWebHistory } from 'vue-router'
import shareds from '@/assets/js/shared'
const shared = new shareds()
const routes = [
    {
        path:'',
        name:'',
        redirect: { path: '/user' },
        component: () => import(/* webpackChunkName: "about" */ '@/views/landingPage.vue')
    },
    {
        path:'/user',
        name:'mainLayout',
        component: () => import(/* webpackChunkName: "about" */ '@/views/public/mainLayoutView.vue'),
        children:[{
            path:'',
            name:'empty',
            // redirect: { path: '/login/4' },
            component: () => import(/* webpackChunkName: "about" */ '@/views/public/empty.vue'),
            props: { message: '' }
        },
        {
            path:'/login/:com_type',
            name:'login',
            component: () => import(/* webpackChunkName: "about" */ '@/views/login/loginView.vue')
        },{
            path:'/register/:com_type',
            name:'register',
            component: () => import(/* webpackChunkName: "about" */ '@/views/register/registerView.vue')
        },{
            path:'/forgetPassword/:com_type',
            name:'forgetPassword',
            component: () => import(/* webpackChunkName: "about" */ '@/views/fgpwd/fgpwdView.vue')
        },{
            path:'/registerInvite/:com_type/:token',
            name:'registerInvite',
            component: () => import(/* webpackChunkName: "about" */ '@/views/register/registerInviteView.vue')
        },{
            path:'/logout/:com_type',
            name:'logout',
            component: () => import(/* webpackChunkName: "about" */ '@/views/login/logout.vue')
        }
        // ,{
        //     path:'/admin',
        //     name:'adminLoginView',
        //     component: () => import(/* webpackChunkName: "about" */ '../views/login/adminloginView.vue')
        // },
        ]
    },{
        path:'/registerNewCompany/:com_type',
        name:'registerNewCompany',
        component: () => import(/* webpackChunkName: "about" */ '@/views/register/registerNewCompanyView.vue')
    },{
        path:'/privacyPolicy',
        name:'privacyPolicy',
        component: () => import(/* webpackChunkName: "about" */ '@/views/privacyPolicy.vue')
    },{
        path:'/termsService',
        name:'termsService',
        component: () => import(/* webpackChunkName: "about" */ '@/views/termsService.vue')
    },{
        path: '/productCard/:code',
        name:'productCard',
        component: () => import(/* webpackChunkName: "about" */ '@/views/productCard.vue')
    },{
        path: '/emailVerify/:CV',
        name:'emailVerify',
        component: () => import(/* webpackChunkName: "about" */ '@/views/emailVerify.vue')
    }
    
]
let previousPath = null;
const router = createRouter({
    base: process.env.VUE_APP_BASE_APP_URL,
    history: createWebHistory(process.env.VUE_APP_BASE_APP_URL),
    routes,
    mode:'history',
    scrollBehavior(to, from, savedPosition) {
        // 滾動到最上方
        return { top: 0 };
    }
})

router.beforeEach((to, from, next) => {

    previousPath = from.fullPath; // 記錄前一個路由的 fullPath

    //處理是否登入過
    //處理是否登入過
    const isAuthenticated = !!shared.decryptionLocalStorageUserInfo(); // 或其他驗證機制
    
    // 判斷是否為登入頁、空頁或未知路由(可能是子系統的 Deep Link)
    const isRedirectTarget = to.name === 'login' || to.name === 'empty' || to.matched.length === 0;

    if (isAuthenticated && isRedirectTarget) {
        const userData = shared.decryptionLocalStorageUserInfo()
        
        // 加密以設定 Cookie
        const encryptedUserData = shared.encryptionLocalStorageUserInfo(userData)
        
        // 取得根網域以設定 Cookie (支援子網域共用)
        const hostname = window.location.hostname;
        const domainParts = hostname.split('.');
        let rootDomain = hostname;
        
        // 簡單判斷：若超過兩層且非 IP，取後兩層 (例如 .auu.tw, .example.com)
        // 若為 localhost 則維持 localhost
        if (domainParts.length > 2 && !/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname)) {
            rootDomain = '.' + domainParts.slice(-2).join('.');
        }

        // 設定 Cookie，有效期 1 小時 (3600秒)
        document.cookie = `dcp-user-token=${encryptedUserData}; domain=${rootDomain}; path=/; max-age=3600; SameSite=Lax`;

        let url = shared.gotoSystemView(userData.com_type)
        
        // 決定目標路徑：如果是未知路由，則使用 fullPath；否則檢查是否有 query.redirect
        const nextPath = (to.matched.length === 0) ? to.fullPath : (to.query?.redirect || '');
        
        // 若有目標路徑且非根目錄，則附加至參數
        if (nextPath && nextPath !== '/' && nextPath !== '/user') {
            url += `?next=${encodeURIComponent(nextPath)}`;
        }
        
        document.location.href = url
    }

    next();

});
export { router, previousPath }; // 匯出 previousPath，其他元件可讀取
export default router